import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import SeamlessIntegration from './SeamlessIntegration';

export default function Blog() {
  return (
    <>
        <Navbar />
        <SeamlessIntegration />
        <Footer />
        <Copyright />
    </>
  )
}